import baseTheme from "@skv/frontend/src/styles/jsvariables.scss";
import nzVariables from "@skv/frontend/src/styles/nz-variables.scss";

import { timingFunctions } from "polished";

export const nzTheme = Object.assign({}, baseTheme, nzVariables, {
  timingFnEaseOut: timingFunctions("easeOutCubic"),
});
